<template>
  <div class="modal-mask" v-on:scroll="scrollMove($el)">
    <div class="modal-wrapper">
      <div class="modal-container d-flex flex-column" v-if="surveyData">
        <div ref="surveyHeader">
          <view-header-insight :surveyData="surveyData"></view-header-insight>
        </div>
        <div class="flex-grow-1">
          <div class="pdt-16 pdr-16 pdl-16 pdb-16">
            <div class="t-subtitle2 font-b l-spacing48">{{$t('1818')}}</div>
            <div class="d-flex align-items-center mgb-12">
                <img src="/images/survey/participant.svg" alt="" class="w-14 mgr-8"><span
                    class="t-color-bodyGrayA t-body3 font-r" v-if="surveyData">{{$t("1819", { str:surveyData.submitCount})}}</span>
            </div>
            <div class="mdc-card mgb-16" v-for="(survey, index) in surveyData.stats" :key="index">
                <div class="pdt-16 pdl-16 pdr-16 pdb-20" v-if="survey && survey.questionType && (survey.questionType.value=='CHOICE_SINGLE' || survey.questionType.value=='CHOICE_MULTIPLE')">
                    <div class="t-subtitle2 font-b l-spacing48">{{index+1}}. {{survey.contents.text}} <img
                            src="/images/survey/survey-point.svg" alt="" class="w-16 d-inline" v-if="survey.essential=== true"></div>
                    <div class="mgt-16" v-for="(information, index1) in survey.statsDto[0].information" :key="index1">
                        <div class="t-body3 font-r t-color-bodyGrayA mgb-4">{{information.content}}</div>
                        <div v-if="information.rate>80" class="t-subtitle2 font-rb mgb-7" :style="`padding-left:calc(${information.rate}% - 15%)`">{{$t("1820", { str:information.rate})}}</div>
                        <div v-else class="t-subtitle2 font-rb mgb-7" :style="`padding-left:calc(${information.rate}%)`">{{$t("1820", { str:information.rate})}}</div>
                        <div class="bg-iconInactiveText position-relative h-2 b-radius4">
                            <div class="bg-iconInactive position-absolute h-6 survey-percentage" :style="`width:${information.rate}%;`">
                            </div>
                        </div>
                        <div class="t-helper t-color-iconInactive mgt-15 d-flex justify-content-end font-r">{{$t("1821", { str1:information.count,str2:survey.statsDto[0].total})}}
                        </div>
                    </div>
                </div>

                <div class="pdt-16 pdl-16 pdr-16 pdb-20" v-if="survey && survey.questionType && survey.questionType.value=='SHORT_ANSWER'">
                    <div class="t-subtitle2 font-b l-spacing48">{{index+1}}. {{survey.contents.text}} <img
                            src="/images/survey/survey-point.svg" alt="" class="w-16 d-inline" v-if="survey.essential=== true"></div>
                    <div class="mgt-16 t-body3 t-color-bodyGrayA l-spacing42 font-r">
                        {{$t('1822')}}
                    </div>
                </div>

                <div class="pdt-16 pdl-16 pdr-16 pdb-20" v-if="survey && survey.questionType && survey.questionType.value=='STARS'">
                  <div class="t-subtitle2 font-b l-spacing48">{{index+1}}. {{survey.contents.text}} <img
                            src="/images/survey/survey-point.svg" alt="" class="w-16 d-inline" v-if="survey.essential=== true"></div>
                    <!-- <div class="mgt-16 t-body3 t-color-bodyGrayA l-spacing42 font-r">
                        단문 응답 유형은 서베이 인사이트가 제공되지 않습니다.
                    </div> -->
                    <div class="d-flex">
                        <div class="d-flex flex-column">
                            <div class="pdl-2 font-rb survey-rank t-center">{{survey.statsDto[0].avg}}</div>
                            <div class="t-body3 t-color-bodyGrayA font-r l-spacing42 t-center">{{$t('1823')}}</div>
                        </div>
                        <div class="flex-grow-1 d-flex flex-column">
                            <div class="flex-grow-1 d-flex align-items-baseline mgl-10 h-6" v-for="(star, index2) in survey.statsDto[0].information" :key="index2">
                                <div class="w-30 t-right">
                                    <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-30 d-inline" v-if="star.rank==5">
                                    <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-24 d-inline" v-if="star.rank==4">
                                    <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-18 d-inline" v-if="star.rank==3">
                                    <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-12 d-inline" v-if="star.rank==2">
                                    <img :src="`/images/survey/${star.rank}star.svg`" alt="" class="w-6 d-inline"  v-if="star.rank==1">
                                </div>
                                <div class="flex-grow-1 mgl-6">
                                    <div class="bg-iconInactiveText position-relative h-2 b-radius4">
                                        <div class="bg-iconInactive position-absolute h-2 star-percentage"
                                            :style="`width: ${(star.count/survey.statsDto[0].total)*100}%;`">
                                        </div>
                                        <!-- <div class="bg-iconInactive position-absolute h-2 star-percentage"
                                            :style="`width: ${Math.round(star.count/survey.statsDto[0].total)}%;`">
                                        </div> -->
                                    </div>

                                </div>
                            </div>
                            <div
                                class="flex-grow-1 d-flex align-items-baseline justify-content-end t-color-bodyGrayA t-caption font-r mgt-9">
                                {{$t("1824", { str:survey.statsDto[0].total})}}
                            </div>
                        </div>
                    </div>

                </div>

                <div class="pdt-16 pdl-16 pdr-16 pdb-20" v-if="survey && survey.questionType && survey.questionType.value=='RANKING'">
                    <div class="t-subtitle2 font-b l-spacing48">{{index+1}}. {{survey.contents.text}}<img
                            src="/images/survey/survey-point.svg" alt="" class="w-16 d-inline" v-if="survey.essential=== true"></div>
                    <div v-for="(answerChoice, index2) in survey.statsDto" :key="index2">
                      <div class="mgt-16 t-body3 t-color-bodyGrayA l-spacing42 font-r">
                          {{answerChoice.choiceAnswerName}}
                      </div>
                      <!-- <div class="pdt-8 pdb-28" v-for="(informationRank, index3) in answerChoice.information" :key="index3"> -->
                        <div class="d-flex mgt-16 justify-content-between" v-if="answerChoice && answerChoice.information && answerChoice.information.length>0">
                          <div  class="d-flex flex-column">
                              <div class="d-flex align-items-center mgb-8 min-w-80" v-for="(informationRank, index3) in answerChoice.information" :key="index3">
                                  <div class="graph-leader" v-if="index3==0" style="background:#68cec6"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3" v-if="index3==0">{{$t('3173',{str:index3+1})}}</div>

                                  <div class="graph-leader" v-if="index3==1" style="background:#f5d479"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3" v-if="index3==1">{{$t('3173',{str:index3+1})}}</div>

                                  <div class="graph-leader" v-if="index3==2" style="background:#737acf"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3" v-if="index3==2">{{$t('3173',{str:index3+1})}}</div>

                                  <div class="graph-leader" v-if="index3==3" style="background:#e97a72"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3" v-if="index3==3">{{$t('3173',{str:index3+1})}}</div>

                                  <div class="graph-leader" v-if="index3==4" style="background:#292b65"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3" v-if="index3==4">{{$t('3173',{str:index3+1})}}</div>
                                  
                                  <div class="graph-leader" v-if="index3==5" style="background:#68cec6"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3" v-if="index3==5">{{$t('3173',{str:index3+1})}}</div>

                                  <div class="graph-leader" v-if="index3==6" style="background:#f5d479"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3" v-if="index3==6">{{$t('3173',{str:index3+1})}}</div>

                                  <div class="graph-leader" v-if="index3==7" style="background:#737acf"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3" v-if="index3==7">{{$t('3173',{str:index3+1})}}</div>

                                  <div class="graph-leader" v-if="index3==8" style="background:#e97a72"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3" v-if="index3==8">{{$t('3173',{str:index3+1})}}</div>

                                  <div class="graph-leader" v-if="index3==9" style="background:#292b65"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3" v-if="index3==9">{{$t('3173',{str:index3+1})}}</div>
                              </div>
                              <!-- <div class="d-flex align-items-center mgb-8 max-w-80">
                                  <div class="min-w-24 h-4 mgr-8" style="background:red"></div>
                                  <div class="font-r t-color-bodyGrayA t-helper">test</div>
                              </div>
                              <div class="d-flex align-items-center mgb-8 max-w-80">
                                  <div class="min-w-24 h-4 mgr-8" style="background:red"></div>
                                  <div class="font-r t-color-bodyGrayA t-helper">test</div>
                              </div>
                              <div class="d-flex align-items-center mgb-8 max-w-80">
                                  <div class="min-w-24 h-4 mgr-8" style="background:red"></div>
                                  <div class="font-r t-color-bodyGrayA t-helper">test</div>
                              </div>
                              <div class="d-flex align-items-center mgb-8 max-w-80">
                                 <div class="min-w-24 h-4 mgr-8" style="background:red"></div>
                                  <div class="font-r t-color-bodyGrayA t-helper">test</div>
                              </div>
                              <div class="d-flex align-items-center mgb-8 max-w-80">
                                  <div class="min-w-24 h-4 mgr-8" style="background:red"></div>
                                  <div class="font-r t-color-bodyGrayA t-helper">test</div>
                              </div> -->
                          </div>
                          
                          <div class="graph border-bottom" v-if="graphvalue(answerChoice)">
                              <doughnut-chart :chart-data="graphvalue(answerChoice)" :height="200" :width="240"></doughnut-chart>
                          </div>
                        </div>

                        <div class="d-flex mgt-16 justify-content-between" v-else>
                          <div  class="d-flex flex-column">
                            <div class="d-flex align-items-center mgb-8 max-w-80">
                                  <div class="graph-leader" style="background:#68cec6"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3">{{$t('3173',{str:1})}}</div>
                              </div>
                              <div class="d-flex align-items-center mgb-8 max-w-80">
                                  <div class="graph-leader" style="background:#f5d479"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3">{{$t('3173',{str:2})}}</div>
                              </div>
                              <div class="d-flex align-items-center mgb-8 max-w-80">
                                  <div class="graph-leader" style="background:#737acf"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3">{{$t('3173',{str:3})}}</div>
                              </div>
                              <div class="d-flex align-items-center mgb-8 max-w-80">
                                 <div class="graph-leader" style="background:#e97a72"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3">{{$t('3173',{str:4})}}</div>
                              </div>
                              <div class="d-flex align-items-center mgb-8 max-w-80">
                                  <div class="graph-leader" style="background:#292b65"></div>
                                  <div class="font-r t-color-bodyGrayB t-body3">{{$t('3173',{str:5})}}</div>
                              </div>
                          </div>
                          <div class="graph border-bottom position-relative d-flex align-items-center justify-content-center">
                              <span class="t-helper t-color-bodyGrayA position-absolute">{{$t('3180')}}</span>
                              <img src="/images/survey/no-data-grph.svg" alt="" height="200" width="240" style="margin: 0 auto">
                              <!-- <doughnut-chart :chart-data="graphvalue(answerChoice)" :height="200" :width="240"></doughnut-chart> -->
                          </div>
                         </div>
                          <!-- <img src="/images/survey/graph1.PNG" alt="" style="width: 246px;margin: 0 auto"> -->
                      <!-- </div> -->
                    </div>
                </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
/**
 * 단독 설문 상세 메인 컴포넌트(independent survey view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import campaignApi from "@/api/campaignApi.js";
import ViewHeaderInsight from "./view/InsightHeader";
// import ViewInformation from "./view/Information";
// import ViewReward from "./view/Reward";
import { surveyMixin } from "@/mixins/survey.js";
import DoughnutChart from "./charts/DoughnutChart";
//import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";

export default {
  name:"InsightView",
  data() {
    return {
      surveyData: null,
      badgesData: null,
      campaignData: null,
      setTabFixed: false,
      graphResult: null,
    };
  },
  components: {
    "view-header-insight": ViewHeaderInsight,
    // Information: ViewInformation,
    // Reward: ViewReward,
    DoughnutChart,
    //ChartJsPluginDataLabels
  },

  mixins: [surveyMixin],

  mounted() {
    this.fatchData();
    // let finalResult = {
    //    labels: ["Babol",	"Cabanatuan",	"Daegu",	"Jerusalem"],
    //     datasets: [{
    //           borderWidth: 1,
    //           backgroundColor: [
    //           "#41B883", "#E46651", "#00D8FF",'rgba(153, 102, 255, 0.2)',                
    //           ],
    //           data: [1000,	500,	1500,	5],
    //           datalabels: {
    //             color:  ["red",	"green",	"purple",	"black"],
    //           },
              
    //         }],
            
    //   };

    //   this.graphResult = finalResult;
  },

  methods: {
    graphvalue(content) {
      let temData = content.information.map(arr=>{
        return arr.rate
      })
      return this.setGraphData(temData)
    },

    setGraphData(temData){
       let finalResult = {
        labels: ["Rank1",	"Rank2",	"Rank3",	"Rank4", "Rank5","Rank6",	"Rank7",	"Rank8",	"Rank9", "Rank10"],
        datasets: [{
              borderWidth: 1,
              backgroundColor: [
              "#68cec6", "#f5d479", "#737acf",'#e97a72','#292b65',"#68cec6", "#f5d479", "#737acf",'#e97a72','#292b65'                
              ],
              data: temData,
              // datalabels: {
              //   color:  ["red",	"green",	"purple",	"black"],
              // },
            }],
      };
      return finalResult
    },
    // 상세 데이터 호출(get survey information data)
    async fatchData() {
      let params = {
        distributionId: this.$route.params.distId,
      };

      // check auth & get survey information data
      let authStatus = await this.checkLogin();
      if (authStatus) {
        surveyApi.surveyInsightView(params).then((response) => {
          this.surveyData = response.data.data;
          //console.log('this.surveyData=>',this.surveyData)
        });
      } 

      
      // get survey campaign data
      campaignApi
        .campaign({
          locationType: "IN_INDEPENDENT_SURVEY",
          locationValue: this.$route.params.distId,
        })
        .then((response) => {
          this.campaignData = response.data.data;
        })
        .catch((err) => {});
    },

    // 상하 스크롤 이동시 탭 고정(move up/down scroll fixed tab)
    scrollMove(el) {
      if (
        parseInt(el.scrollTop) >= parseInt(this.$refs.surveyHeader.offsetHeight)
      ) {
        this.setTabFixed = true;
      } else {
        this.setTabFixed = false;
      }
    },
  },
};
</script>
<style scoped>
    .survey-p {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background-color: var(--Iconinactive);
      }

      .bg-iconInactiveText {
          background: var(--IconinactiveText) !important;
      }

      .survey-percentage {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
          top: -2px;
      }

      .survey-percentage:after {
          content: '';
          position: absolute;
          right: 0;
          top: -6px;
          width: 0;
          height: 9px;
          margin: 3.5px 0 4.5px;
          border: solid 1px var(--Iconinactive);
      }

      .survey-rank {
          font-size: 47px;
      }

      .t-font-6 {
          font-size: 7px;
      }

      .star-percentage {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
          top: 0px;
      }
      
            /* canvas {
                -moz-user-select: none;
                -webkit-user-select: none;
                -ms-user-select: none;
                font-weight:700;  
            } */
        
</style>